<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import shield_svg from '@img/guarantee/shield.svg';
import star_svg from '@img/guarantee/star.svg';
import clock_svg from '@img/guarantee/clock.svg';
import money_svg from '@img/guarantee/money.svg';
import delivery_svg from '@img/guarantee/delivery.svg';
import certificate_svg from '@img/guarantee/certificate.svg';
import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue";
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue";
import PopularCollectionsSlider from "@js/components/Sliders/PopularCollectionsSlider.vue";
import B2BSlider from "@js/components/Sections/B2B/B2BSlider.vue";
import {useCallbackStore} from "@js/store/CallbackStore.js";
import b2bBuilderImg from '@img/callback/b2bbuilder.webp'

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForBuildersPage",
    components: {
        B2BSlider,
        PopularCollectionsSlider,
        InfoCards,
        Breadcrumbs,
        MobileTopBar,
    },
    data() {
        return {
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'Гарантия качества керамической плитки и керамогранита',
                    description: 'Наша продукция сертифицирована по ГОСТ и проходит жёсткий контроль на каждом этапе. Качество и безопасность в каждом фрагменте.',
                },
                {
                    logo: certificate_svg,
                    title: 'Сертифицированные экологичные материалы',
                    description: 'Используем только высококачественные, экологически чистые компоненты. Плитка устойчива к нагрузкам, влаге и перепадам температур.',
                },
                {
                    logo: clock_svg,
                    title: 'Точное соблюдение сроков поставки',
                    description: 'Организуем доставку строго в оговорённые сроки благодаря собственному автопарку и отлаженной логистике.',
                }
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'Прозрачное ценообразование без скрытых доплат',
                    description: 'Честные цены заранее, без неожиданных комиссий. Специальные условия для оптовых клиентов и постоянных партнёров.',
                },
                {
                    logo: delivery_svg,
                    title: 'Гарантия сохранности при доставке',
                    description: 'Доставляем материалы по строгим стандартам безопасности, чтобы плитка и керамогранит прибыли без повреждений.',
                },
                {
                    logo: star_svg,
                    title: 'Гарантийное обслуживание плитки',
                    description: 'Мы уверены в качестве наших изделий и предоставляем официальную гарантию на все виды плитки.',
                }
            ],
        }
    },
    methods: {
      openForm(){
          this.callbackStore.showBaseCallbackPopup({
              title: 'Стать нашим партером',
              bitrix_title: 'Заявка на партнерство для строителей',
              img_src: b2bBuilderImg,
          })
      }
    },
    setup() {
        const callbackStore = useCallbackStore()

        return {callbackStore}
    }
})
</script>

<template>
    <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div class="flex items-center justify-center">
                    <div>
                        <Breadcrumbs class="text-white"/>
                        <h1 class="text-2xl md:text-4xl font-bold mb-5">
                            B2B-решения для профессиональных строителей
                        </h1>
                        <p class="md:text-xl mb-5 md:max-w-[80%]">
                            Присоединяйтесь к партнёрам Moda Ceramics и получайте надёжные поставки, прозрачные условия
                            и персональную поддержку.
                        </p>
                        <button @click.prevent="openForm"
                            class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                            Стать партнёром
                        </button>
                    </div>
                </div>
                <div class="flex items-center justify-center">
                    <img src="@img/b2b/builders/top-bg.png" class="max-h-[500px]"/>
                </div>
            </div>
        </div>
    </div>
    <section class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px]  md:mb-20">
        <div class="container pt-10 md:pt-20">
            <h2 class="text-2xl md:text-3xl font-bold mb-5">
                Наши услуги для строителей
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div>
                    <div class="grid grid-cols-2 gap-3 md:gap-5 h-full">
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>3D-визуализация дизайн-проектов (бесплатно)</p>
                        </div>
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>Доставка образцов по адресу</p>
                        </div>
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>Индивидуальный подбор материалов по стилю и бюджету</p>
                        </div>
                        <div
                            class="flex items-center justify-center bg-grayBg p-4 md:p-6 rounded-lg md:rounded-2xl font-semibold md:font-medium text-center text-sm md:text-base lg:text-xl">
                            <p>Бесплатная доставка по Москве и Московской области</p>
                        </div>
                    </div>
                </div>
                <div>
                    <img src="@img/b2b/builders/main.webp" class="object-contain" alt="B2B для строителей"
                         title="B2B для строителей"/>
                </div>
            </div>
        </div>
    </section>

    <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20"/>

    <div class="container">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
            <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                <h2 class="text-2xl md:text-3xl font-bold mb-5">
                    Мы возьмём на себя часть ваших забот
                </h2>
                <p class="mb-3">
                    Работа строителя насыщена и требует внимания к множеству деталей. Консультации, подбор материалов и
                    логистика отвлекают от основной задачи — строительства.
                </p>
                <p class="mb-3">
                    Мы занимаемся продажей плитки более 20 лет и знаем, что важно вашим клиентам.
                </p>
                <p class="mb-3">
                    Готовы взять на себя:
                </p>
                <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                    <li>подбор плитки по стилю, бюджету и техническим требованиям;</li>
                    <li>3D-визуализацию и раскладку на стены;</li>
                    <li>комплектацию и доставку материалов.</li>
                </ul>
            </div>
            <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                <h2 class="text-2xl md:text-3xl font-bold mb-5">
                    Как начать сотрудничество
                </h2>
                <p class="mb-3">
                    Оставьте заявку, и мы подготовим для вас индивидуальное предложение с учётом объёмов и особенностей
                    вашего проекта. Наш менеджер свяжется с вами в течение рабочего дня.
                </p>
                <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                    <li>специальные цены для крупных заказов;</li>
                    <li>доступ в личный кабинет для онлайн-заказов;</li>
                    <li>поддержка и консультации на каждом этапе.</li>
                </ul>
                <button @click.prevent="openForm"
                    class="mt-4 flex justify-center items-center text-black md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase">
                    Оставить заявку
                </button>
            </div>
        </div>
    </div>
    <div class="max-md:ps-5 sm:container">
        <div class="mb-10">
            <h2 class="text-2xl font-semibold mb-6">
                Другие услуги B2B
            </h2>
            <B2BSlider/>
        </div>
    </div>
    <div class="container">
        <PopularCollectionsSlider/>
    </div>
</template>

<style scoped lang="scss">

</style>
